

<app-leave-application-list></app-leave-application-list>
<app-leave-application-form></app-leave-application-form>